import React from 'react';
import styles from './styles.scss';

const PopupCentered = ({ children }) => (
  <div className={styles.popup}>
    {children}
  </div>
);

export default PopupCentered;
